"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Go = createSvgIcon(
  <path d="M17.0788 12.5H5V11.5H17.0788L11.2865 5.7077L12 5L19 12L12 19L11.2865 18.2923L17.0788 12.5Z" />,
  "Go",
)

const GoIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <Go sx={{ fill: _fill, ...sx }} {...rest} />
}

export default GoIcon
